import { Directive, ElementRef, inject, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { PopoverDesignTokens } from '@openng/optimus-ui-themes/types/popover';
import { filter } from 'rxjs';
import { Popover } from '@openng/optimus-ui/popover';

@Directive({})
export abstract class NavPopoverBase {

	readonly isPopoverOpen = signal(false);

	readonly popover = viewChild('popover', { read: Popover });
	readonly popoverTarget = viewChild('popoverTarget', { read: ElementRef });
	readonly iconContainer = viewChild<ElementRef>('iconContainer');
	readonly popoverContent = viewChild<ElementRef>('popoverContent');

	readonly popoverDt = {
		root: {
			background: '{surface.200}',
		},
	} satisfies PopoverDesignTokens;

	protected readonly router = inject(Router);
	private openedByKeyboard = false;

	constructor() {
		this.router.events.pipe(
			filter(event => event instanceof NavigationStart),
			takeUntilDestroyed(),
		).subscribe(() => this.popover()?.hide());
	}

	onPopoverShow() {
		this.isPopoverOpen.set(true);
		if (this.openedByKeyboard) {
			setTimeout(() => {
				const content = this.popoverContent()?.nativeElement as HTMLElement;
				content?.querySelector<HTMLElement>('a, button, [tabindex]:not([tabindex="-1"])')?.focus();
			});
		}
	}

	onClick($event: Event) {
		this.openedByKeyboard = $event instanceof KeyboardEvent;
		this.popover().toggle($event, this.popoverTarget().nativeElement);
	}

	onPopoverEscape($event: KeyboardEvent) {
		$event.stopPropagation();
		this.popover().hide();
		this.iconContainer()?.nativeElement.focus();
	}
}
